import Vue from 'vue'
import VueI18n from 'vue-i18n'

const DEFAULT_LOCALE = 'en'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || DEFAULT_LOCALE,
  messages: {
    'en': {
      'Are you sure to delete {user}?': '<b>Are you sure to delete user</b> <br> {user}?',
      'Are you sure to delete {team}?': '<b>Are you sure to delete team</b> <br> {team}?',
      'Are you sure to delete {questionnaire}?': '<b>Are you sure to delete questionnaire</b> <br> {questionnaire}?',
      'Are you sure to delete {category}?': '<b>Are you sure to delete category</b> <br> {category}?',
      'Are you sure to delete {question}?': '<b>Are you sure to delete question</b> <br> {question}?',
      'Are you sure to delete {news}?': '<b>Are you sure to delete news</b> <br> {news}?',
      'Showing {from} - {to} of {total} Entries': 'Showing {from} - {to} of {total} Entry | Showing {from} - {to} of {total} Entries',
      '{team} members at a glance': '{team} members at a glance',
      'by {author}': 'by {author}',
      'action': 'action | actions',
      'hourCount': '{count} hour | {count} hours',
      'hour': 'hour | hours',
      'day': 'day | days',
      '{team} results': '{team} results',
      'GDPR': 'General Data Protection Regulation',
      'GDPR Title': 'Declaration of consent',
      'GDPR Info': 'I hereby give my consent that my personal data and information (name, company email address, query values and answers) may be stored, processed and evaluated. This is done exclusively for the purpose of internal company use. I declare my consent to the collection and use of my details for recurring surveys to promote internal company communication, the internal company climate and team culture, as well as to optimise cooperation.  \n \n' +
        'This survey is carried out by using the online tool TeamWave of the company WeGenics GmbH. A change of the query values is not possible after sending the answers. \n' +
        'I can view my data at any time under my personal access data on the company-specific domain. \n' +
        'The data may be used for analysis purposes of the team and company development as well as optimisation of the tool services.\n' +
        'I can revoke this consent at any time in writing in the form of an e-mail to the contact data stored in the online tool Teamwave under the menu item INFO. A revocation does not affect the legality of the processing that has taken place up to that point.',
      'GDPR Accept': 'Yes, I agree!',
      'GDPR Decline': 'No, I do not agree',
      'License information': 'License information',
      'for {teams}': 'for {teams}'
    },
    'de': {
      'My Company': 'Mein Unternehmen',
      'My Queries': 'Meine Abfragen',
      'My Team': 'Mein Team',
      'My Tasks': 'Meine Aufgabenliste',
      'Tasks': 'Aufgabenliste',
      'Search...': 'Suche...',
      'more': 'mehr',
      'Latest news': 'Aktuelle Nachrichten',
      'Open': 'Offen',
      'Completed': 'Erledigt',
      'slider': 'Schieberegler',
      'text': 'Text',
      'Team Engagement COMPASS': 'Team Engagement COMPASS',
      'Average': 'Durchschnitt',
      'Last Query': 'Letzte Abfrage',
      'Query': 'Abfrage',
      'Actions': 'Aktionen',
      'Workload': 'Arbeitspensum',
      'Satisfaction': 'Zufriedenheit',
      'Great feedback': 'tolles Feedback',
      'Stressed out': 'gestresst',
      'Not delivered': 'nicht geliefert',
      'Thank you': 'Danke',
      'Help': 'Hilfe',
      'Support': 'Unterstützung',
      'Postponement': 'Terminverschiebung',
      'Good project partners': 'gute Projektpartner',
      'Good suggestions': 'gute Vorschläge',
      'Handshake quality': 'Handschlagsqualität',
      'Chaotic': 'chaotisch',
      'Too much at once': 'zu viel auf einmal',
      'Missing disclosures': 'fehlende Angaben',
      'Too many mails': 'zu viele Mails',
      'Collaboration': 'Zusammenarbeit',
      'Is behind me': 'steht hinter mir',
      'Reliability': 'Verlässlichkeit',
      'Punctuality': 'Termintreue',
      'Bad preparation': 'schlechte Vorbereitung',
      'Outrageous demand': 'unverschämte Forderung',
      'Ideas': 'Ideen',
      'Question': 'Frage',
      'Wordcloud': 'Wordcloud',
      'My company at a glance': 'Mein Unternehmen auf einem Blick',
      'Logout': 'Ausloggen',
      'Feedback': 'Feedback',
      'external': 'extern',
      'action': 'Aktion',
      'hourCount': '{count} Stunde | {count} Stunden',
      'hour': 'Stunde | Stunden',
      'day': 'Tag | Tage',
      '{team} results': '{team} Ergebnis',
      'My Account': 'Mein Benutzerkonto',
      'Change Password': 'Passwort ändern',
      'New Password': 'Neues Passwort',
      'Repeat New Password': 'Wiederhole das neue Passwort',
      'No notifications': 'Keine Nachrichten',
      'Notifications': 'Nachrichten',
      'Login credentials': 'Login Daten',
      'Login name': 'Login Name',
      'Password': 'Passwort',
      'First Name': 'Vorname',
      'Last Name': 'Zuname',
      'Email': 'E-Mail',
      'Save': 'SPEICHERN',
      'Are you sure to logout?': 'Möchten Sie TeamWave verlassen?',
      'Cancel': 'Nein',
      'All news': 'Alle Nachrichten',
      'All News': 'Alle Nachrichten',
      'Showing {from} - {to} of {total} Entries': 'Auflistung {from} - {to} von {total}',
      'Date': 'Datum',
      'Title': 'Titel',
      'Status': 'Status',
      'Results': 'Ergebnis',
      'Query selection': 'Abfragen Auswahl',
      'Result selection': 'Ergebnis Auswahl',
      'Queries': 'Abfragen',
      'Most recent data': 'Aktuellstes Ergebnis',
      'Select': 'Auswahl',
      'Select time': 'Zeit wählen',
      'Team selection': 'Team Auswahl',
      'Export as PDF': 'Als PDF exportieren',
      'Team Engagement Compass': 'Team Engagement Kompass',
      'Last 1 month': 'Letztes Monat',
      'Last 2 months': 'Letzten 2 Monate',
      'Last 3 months': 'Letzten 3 Monate',
      'Last 6 months': 'Letzten 6 Monate',
      'Last 9 months': 'Letzten 9 Monate',
      'Last 12 months': 'Letzten 12 Monate',
      'Last 15 months': 'Letzten 15 Monate',
      'Last 18 months': 'Letzten 18 Monate',
      'Team members': 'Team Mitglieder',
      '{team} members at a glance': '{team} Mitglieder auf einen Blick',
      'Join Date': 'Benutzer seit',
      'Last Login': 'Letzter Login',
      'Roles': 'Rolle',
      'Users': 'User',
      'Add User': 'Neuer Benutzer',
      'Add New User': 'Benutzer anlegen',
      'Account Active': 'Benutzerkonto aktiv',
      'External User': 'Externer Benutzer',
      'User Administration': 'Benutzer Verwaltung',
      'User Account and User Settings': 'Benutzerkonto und Einstellungen',
      'Add Team': 'Neues Team',
      'Add New Team': 'Neues Team',
      'Team Visibility': 'Team Sichtbarkeit',
      'detailed': 'detailliert',
      'accumulated': 'akkumuliert',
      'Type for search...': 'Auswahl durch tippen aktivieren...',
      'Add Leader': 'Neuer Leader',
      'Add Member': 'Neuer Member',
      'Add Members': 'Neuer Member',
      'Added at': 'Zugefügt am',
      'Subteam': 'Sub-Team',
      'Team Configuration': 'Team Konfiguration',
      'Questionnaires': 'Fragenkataloge',
      'Add questionnaire': 'Neue Frage',
      'Add Questionnaire': 'Neuer Fragenkatalog',
      'Team Organization': 'Team Struktur',
      'Sub Teams': 'Sub-Teams',
      'Add Sub Team': 'Neues Sub-Team',
      'Create Subteam for Leader': 'Sub-Team für Leader anlegen',
      'Subteam Name': 'Sub-Team Name',
      'New Questionnaire': 'Fragenkatalog erstellen',
      'Questionnaire Title': 'Fragenkatalog Titel',
      'Questions': 'Fragen',
      'Question Topic': 'Bereich',
      'Type': 'Typ',
      'Allocated Teams': 'Teams',
      'Interval': 'Intervall',
      'Time': 'Uhrzeit',
      'Repeat every': 'Wiederholen jede',
      'Repeat at': 'Wiederholen am',
      'Week': 'Woche',
      'Month': 'Monat',
      'Working day': 'Werktag',
      'Add Question': 'Neue Frage',
      'Add Questions': 'Neue Fragen',
      'Category': 'Bereich',
      'Edit Question': 'Frage Bearbeiten',
      'Create Question': 'Frage erstellen',
      'Text slider scale \'minimum\' (red)': 'Text Schieberegler \'minimum\' (red)',
      'Text slider scale \'maximum\' (green)': 'Text Schieberegler \'maximum\' (green)',
      'Question Library': 'Fragenbibliothek',
      'Question List': 'Fragenliste',
      'Questionnaire Management': 'Fragenkatalog bearbeiten',
      'Edit Question Topic': 'Fragengebiet bearbeiten',
      'Add Question Topic': 'Neues Fragengebiet',
      'Create Question Topic': 'Fragengebiet erstellen',
      'Question Topics': 'Fragengebiete',
      'Created at': 'Erstellt am',
      'Create News': 'News erstellen',
      'Preview': 'Vorschau',
      'Max size': 'Max größe',
      'Content': 'Inhalt',
      'Visibility': 'Sichtbarkeit',
      'Published': 'Veröffentlichung',
      'global': 'Global',
      'team': 'Teamauswahl',
      'Delete': 'Löschen',
      'News Overview': 'News Überblick',
      'Created by': 'Erstellt von',
      'Add News': 'Neue News',
      'Concerned': 'Betrifft',
      'Filter by team': 'Nach Team filtern',
      'Created at {date} by {createdBy}': 'Erstellt am {date} von {createdBy}',
      'Due date': 'Fällig',
      'Concern': 'Betrifft',
      'Complete Task': 'Aufgabe Erledigt',
      'Trigger': 'Auslöser',
      'Questionnaire': 'Abfrage',
      'Value': 'Ergebniswert',
      'Subtasks': 'Teilaufgaben',
      'Description': 'Beschreibung',
      'Edit Subtask': 'Teilaufgabe Ändern',
      'Add Subtask': 'Neue Teilaufgabe',
      'user': 'Team Member',
      'Create Task': 'Neue Aufgabe',
      'Open Tasks': 'Offene Aufgaben',
      'Completed Tasks': 'Erledigte Aufgaben',
      'Are you sure to delete {task}?': 'Willst du {task} wirklich löschen?',
      'Invite User': 'Benutzer einladen',
      'by {author}': 'von {author}',
      'cancel': 'Abbrechen',
      'English': 'Englisch',
      'German': 'Deutsch',
      'Your package does not allow any additional question topics.<br>For more informations please contact your administrator.': 'Dein Paket erlaubt keine weiteren Fragengebiete.<br>Für mehr Informationen wende dich bitte an deinen Administrator.',
      'Can\'t add questions because this is a locked questionnaire.<br>For more informations please contact your administrator': 'Dies ist ein gesperrter Fragebogen in dem keine neuen Fragen eingefügt werden können.<br>Für mehr Informationen wende dich bitte an deinen Administrator.',
      'Questionnaire active until': 'Fragebogen aktiv für',
      'You reached the questionnaire limit.<br>For more informations please contact the administrator.': 'Sie haben das Limit an Fragebögen erreicht.<br>Für mehr Informationen kontaktiere bitte den Administrator.',
      'Information': 'Information',
      'You reached the user limit.<br>For more informations please contact the administrator.': 'Sie haben das Limit an Benutzern erreicht.<br>Für mehr Informationen kontaktiere bitte den Administrator.',
      'note upper and lower case': 'beachte Gross- und Kleinschreibung',
      'GDPR': 'Datenschutz-Grundverordnung',
      'GDPR Title': 'Einverständniserklärung',
      'GDPR Info': 'Hiermit gebe ich mein Einverständnis, dass meine personenbezogenen Daten und Angaben (Name, Firmen-Emailadresse, Abfragewerte und Antworten) gespeichert, verarbeitet und ausgewertet werden dürfen. Dies erfolgt ausschließlich zum Zweck einer unternehmensinternen Verwendung. Ich erkläre meine Einwilligung, dass meine Angaben zu wiederkehrenden Befragungen zur Förderung der firmeninternen Kommunikation, des firmeninternen Klimas und der Teamkultur, sowie der Optimierung der Zusammenarbeit erhoben und genutzt werden.  \n \n' +
        'Diese Erhebung erfolgt durch die Nutzung des OnlineTools TeamWave der Firma WeGenics GmbH. Eine Veränderung der Abfragewerte ist nach Absenden der Antworten nicht mehr möglich. \n' +
        'Ich kann meine Daten jederzeit unter meinen persönlichen Zugangsdaten auf der unternehmensspezifischen Domain einsehen. \n' +
        'Die Daten dürfen zu Analysezwecken der Team- und Unternehmensentwicklung sowie Optimierung der Tooldienste verwendet werden.\n' +
        'Diese Einwilligung kann ich jederzeit schriftlich im Form einer E-Mail an die Kontaktdaten, die im OnlineTool Teamwave unter dem Menüpunkt INFO hinterlegt sind, widerrufen. Durch einen Widerruf wird die Rechtmäßigkeit der bis dahin erfolgten Verarbeitung nicht berührt.',
      'GDPR Accept': 'Ja, ich bin einverstanden!',
      'GDPR Decline': 'Nein, ich bin nicht Einverstanden',
      'License information': 'Lizenzinformationen',
      'By saving this information you confirm that you are taking part in this query.': 'Mit dem Speichern meiner Eingaben bestätige ich, dass ich an dieser Abfrage teilnehme und damit einverstanden bin, dass meine Angaben verarbeitet und ausgewertet werden.',
      'CW': 'KW',
      'Positive Experiences': 'Positive Erfahrungen',
      'Suggestions': 'Verbesserungsvorschläge',
      'We look forward to know your positive experiences you have with TeamWave and where you think we can improve. Thank you!': 'Bitte senden Sie uns Ihre positiven Erfahrungen mit TeamWave und Ihre Vorschläge, was wir noch verbessern können. Vielen Dank.',
      'Send': 'Absenden',
      'Thank you for your feedback!': 'Vielen Dank für dein Feedback!',
      'Development Team and Members': 'Entwicklung Team und Teammitglieder',
      "In Progress": "In Bearbeitung",
      'Successfully saved.': 'Erfolgreich gespeichert.',
      'Performance Trend': 'Leistungsbasis',
      'Not Completed': 'Nicht Teilgenommen',
      'Report selection': 'Report Auswahl',
      'Upload': 'Hochladen',
      'New Picture': 'Neues Bild',
      'Reset password': 'Passwort zurücksetzen',
      'Password reset error': 'Passwort zurücksetzen fehlgeschlagen',
      'Password reset success': 'Passwort zurücksetzen erfolgreich',
      'Your request for password reset successfully submitted': 'Deine Anfrage für das Zurücksetzen des Passwords war erfolgreich',
      'Please check your e-mail': 'Bitte prüfe deinen Email Posteingang',
      'An error occurred': 'Ein Fehler ist aufgetreten',
      'Please check if Login name is correct': 'Bitte prüfe ob dein Login Name korrekt ist',
      'Submit': 'Abschicken',
      'Welcome': 'Willkommen',
      'Username': 'Benutzername',
      'Forgot password': 'Passwort Vergessen',
      'Date Range': 'Zeitraum',
      'Start': 'Start',
      'End': 'Ende',
      'Export': 'Exportieren',
      'to': 'bis',
      'All Queries': 'Alle Abfragen',
      'Missing Value': 'Fehlender Wert',
      'Missing team selection': 'Fehlende Team auswahl',
      'PDF Typ': 'PDF Type',
      'Period': 'Zeitraum',
      'From Query': 'Von Abfrage',
      'To Query': 'Bis Abfrage',
      'for {teams}': 'für {teams}',
      'Alert Values': 'Schwellwerte',
      'Alert at': 'Warnung ab',
      'Target at': 'Zielwert',
      'You have unsaved changes. Do you really want to leave?': 'Sie haben ungespeicherte Änderungen. Sind Sie sicher dass sie die Seite verlassen wollen?',
      'Inactive': 'Inaktiv'
    }
  },
  dateTimeFormats: {},
  formatFallbackMessages: true,
  silentTranslationWarn: true
})

export default i18n
